module.exports = __webpack_public_path__ + "static/media/insider.cb61684e.jpeg";